import React, { useEffect, useState } from "react";
import { DialogComponent } from "../../../common/DialogComponent";
import IDFProtectionPlanUpgradeConfirmation from "../../../Dialogs/protectionPlan/IDFProtectionPlanUpgradeConfirmation";
import * as ProtectionPlanActions from "../../../../store/protectionPlanService/idf/actions";
import { useDispatch } from "react-redux";
import IDFProtectionPlanUpgradePackage from "../../../Dialogs/protectionPlan/IDFProtectionPlanUpgradePackage";
import IDFProtectionPlanUpgradeCompleteDialog from "../../../Dialogs/protectionPlan/IDFProtectionPlanUpgradeCompleteDialog";
import ErrorBoundary from "../../../common/ErrorBoundary";

interface IProps {
    initialDialog: string;
    packageIndex: number;
    onClose: any;
    history: any;
}

const IDFProtectionPlanDialogContainer: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const requestBillingInfo = (forceLoad: boolean) => dispatch(ProtectionPlanActions.actionCreators.requestBillingInfo(forceLoad));
    const requestProtectionPlan = (forcefullyRefresh: boolean) => dispatch(ProtectionPlanActions.actionCreators.requestProtectionPlan(forcefullyRefresh));

    const [state, setState] = useState({
        packageIndex: -1,
        nextBillingDate: "",
    });

    const [upgradeConfirmationDialog, setUpgradeConfirmationDialog] = useState(false);
    const [upgradeDialog, setUpgradeDialog] = useState(false);
    const [upgradeCompleteDialog, setUpgradeCompleteDoneDialog] = useState(false);
    const [newInitialDialog, setNewInitialDialog] = useState(props.initialDialog);
    const handleUpgradeConfirmationDialog = (value: string): any => {
        if (value === "show") {
            setUpgradeConfirmationDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setUpgradeConfirmationDialog(false);
            props.onClose();
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setUpgradeConfirmationDialog(false);
            props.onClose();
        }
    };

    const closeUpgradeConfirmationDialog = () => {
        document.body.classList.remove("no_scroll");
        setUpgradeConfirmationDialog(false);
        setNewInitialDialog("");
    };

    const handlePackageUpgradeDialog = (value: string): any => {
        if (value === "show") {
            setUpgradeDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setUpgradeDialog(false);
            requestBillingInfo(true);
            props.onClose();
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setUpgradeDialog(false);
            requestBillingInfo(true);
            props.onClose();
        } else if (value === "submitted") {
            document.body.classList.remove("no_scroll");
            setUpgradeDialog(false);
        }
    };

    const closeUpgradeAndOpenCompletionDialog = (operationDate: string) => {
        setState({
            ...state,
            nextBillingDate: operationDate,
        });
        handlePackageUpgradeDialog("submitted");
        handleUpgradeDoneDialog("show");
    };

    const showPackageUpgrade = (event: any) => {
        closeUpgradeConfirmationDialog();
        handlePackageUpgradeDialog("show");
    };

    const handleUpgradeDoneDialog = (value: string): any => {
        if (value === "show") {
            setUpgradeCompleteDoneDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setUpgradeCompleteDoneDialog(false);
            props.onClose();
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setUpgradeCompleteDoneDialog(false);
            requestBillingInfo(false);
            requestProtectionPlan(true);
            props.onClose();
        }
    };

    const loadInitialDialog = () => {
        setState({ ...state, packageIndex: props.packageIndex });
        if (newInitialDialog === "ProtectionPlanUpgradeConfirmation") {
            setUpgradeConfirmationDialog(true);
        } else if (newInitialDialog === "ProtectionPlanUpgradePackage") {
            setUpgradeDialog(true);
        }
    };
    useEffect(() => {
        if (props != null) {
            loadInitialDialog();
        }
    }, [props]);

    return (
        <React.Fragment>
            {state.packageIndex !== -1 && (
                <React.Fragment>
                    <ErrorBoundary componentName="Protection Plan Upgrade Confirmation Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                        {upgradeConfirmationDialog && (
                            <DialogComponent
                                dialogId="protection-plan-upgrade-confirmation-dialog"
                                title="Upgrade Confirmation"
                                datalayerEvent="Protection Plan - Close confirmation"
                                closeDialog={() => {
                                    handleUpgradeConfirmationDialog("close");
                                }}
                            >
                                <IDFProtectionPlanUpgradeConfirmation
                                    closeDialog={() => {
                                        handleUpgradeConfirmationDialog("close");
                                    }}
                                    showUpgradeDialog={() => {
                                        showPackageUpgrade("show");
                                    }}
                                    packageIndex={state.packageIndex}
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>

                    <ErrorBoundary componentName="Protection Plan Upgrade Package Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                        {upgradeDialog && (
                            <DialogComponent
                                dialogId="protection-plan-package-upgrade-dialog"
                                title="Package Upgrade"
                                datalayerEvent="Protection Plan - Close cart summary"
                                closeDialog={() => {
                                    handlePackageUpgradeDialog("close");
                                }}
                            >
                                <IDFProtectionPlanUpgradePackage
                                    dialogId="protection-plan-package-upgrade-dialog"
                                    closeDialog={() => {
                                        handlePackageUpgradeDialog("close");
                                    }}
                                    packageIndex={state.packageIndex}
                                    closeUpgradeAndOpenCompletionDialog={closeUpgradeAndOpenCompletionDialog}
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>

                    <ErrorBoundary componentName="Protection Plan Upgrade Complete Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                        {upgradeCompleteDialog && (
                            <DialogComponent
                                dialogId="protection-plan-upgrade-done-dialog"
                                title="Plan Upgrade Done"
                                datalayerEvent="Protection Plan - Close completion"
                                closeDialog={() => {
                                    handleUpgradeDoneDialog("close");
                                }}
                            >
                                <IDFProtectionPlanUpgradeCompleteDialog
                                    dialogId="protection-plan-upgrade-done-dialog"
                                    closeDialog={() => {
                                        handleUpgradeDoneDialog("close");
                                    }}
                                    nextOperationDate={state.nextBillingDate}
                                    packageIndex={state.packageIndex}
                                    history={props.history}
                                />
                            </DialogComponent>
                        )}
                    </ErrorBoundary>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default IDFProtectionPlanDialogContainer;
